import { Switch } from "react-router-dom";
import AuthRoute from "components/AuthRoute";
import { PermissaoEnum } from "resources/enums/permissao";

import UnidadeDetalhesPage from "./Detalhes";
import UnidadeImportacaoPage from "./Importacao";
import UnidadesListagemPage from "./Listagem";

function UnidadesPages() {
  return (
    <Switch>
      <AuthRoute
        exact
        path="/cadastros/unidades"
        component={UnidadesListagemPage}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Unidade.Visualizar,
        ]}
      />
      <AuthRoute
        exact
        path="/cadastros/unidades/importacao"
        component={UnidadeImportacaoPage}
        permissions={[PermissaoEnum.Backoffice.Administrativo.Unidade.Criar]}
      />
      <AuthRoute
        exact
        path="/cadastros/unidades/new"
        component={UnidadeDetalhesPage}
        permissions={[PermissaoEnum.Backoffice.Administrativo.Unidade.Criar]}
      />
      <AuthRoute
        exact
        path="/cadastros/unidades/:id"
        component={UnidadeDetalhesPage}
        permissions={[PermissaoEnum.Backoffice.Administrativo.Unidade.Editar, PermissaoEnum.Backoffice.Administrativo.Unidade.Visualizar]}
      />
    </Switch>
  );
}

export default UnidadesPages;
